"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var awsui_table_preferences_1 = require("./awsui-table-preferences");
var awsui_cards_page_size_selector_1 = require("./awsui-cards-page-size-selector");
var awsui_cards_content_selector_1 = require("./awsui-cards-content-selector");
var CardsPreferencesWrapper = /** @class */ (function (_super) {
    __extends(CardsPreferencesWrapper, _super);
    function CardsPreferencesWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'cards';
        return _this;
    }
    CardsPreferencesWrapper.prototype.findPageSizeSelector = function () {
        return new awsui_cards_page_size_selector_1.default(this.find('awsui-cards-page-size-selector').getElement());
    };
    CardsPreferencesWrapper.prototype.findContentSelector = function () {
        return new awsui_cards_content_selector_1.default(this.find('awsui-cards-content-selector').getElement());
    };
    return CardsPreferencesWrapper;
}(awsui_table_preferences_1.BaseCollectionPreferencesWrapper));
exports.default = CardsPreferencesWrapper;
//# sourceMappingURL=awsui-cards-preferences.js.map